import { UserModule } from "@/store/modules/user";

const WIDTH = 768 // refer to Bootstrap's responsive design

export function HasPer(per: string[]): boolean {
    return per.some(p => UserModule.permissions.includes(p))
}

export function IsMobile(): boolean {
    const rect = document.body.getBoundingClientRect()
    if (rect.width - 1 < WIDTH) return true
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function IsChrome(): boolean {
    return /Chrome/i.test(navigator.userAgent)
}

export function IsIOS(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export function IsAndroid(): boolean {
    return /Android/i.test(navigator.userAgent)
}

export function detectMiniProgram(): boolean {
    // 使用 window.wx 和 window.wx.miniProgram 检测小程序环境
    // 或者使用其他小程序特定的环境变量
    if (typeof window !== 'undefined' && (window as any).wx && (window as any).wx.miniProgram) {
        return true
    }

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('platform') === 'miniprogram') {
        return true
    }

    return false

  }